export function toShortTimeString(d, locale) {
    return d.toLocaleTimeString(locale).replace(/:\d\d(?!:)/, "");
}

export function currentTimeZone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}